import {AbstractModel, JsonObject, JsonProperty} from '../../../../../../../core/src/public-api';
import {PricingFormulaItem} from './pricing-formula-item';

@JsonObject('model.PricingFormula')
export class PricingFormula extends AbstractModel {

  @JsonProperty([PricingFormulaItem], 'items')
  items: PricingFormulaItem[];
}
